<style lang="less" scoped>
.win_input {height: 40px;width: 100%;margin-top: 8px;}
.login_btn {display: block;width: 350px;height: 35px;text-align: center;background: #0090ff;border: none;color: #FFFFFF;margin: 0px auto;margin-top: 30px;border-radius: 3px;}
.tip_p {width: 350px;margin: 5px auto;color: #000;font-size: 14px;}
.tip_p span {display: inline-block;cursor: pointer;}
/deep/.win_input.el-input {width: 350px;}
/deep/.phones.el-input {width: 236px;}
/deep/.phone.el-input {width: 206px;}

.msg {-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;-khtml-user-select:none;user-select:none;}
.fl{ float: left;}
.fr{ float: right;}
</style>

<template>
  <div class="form-wrap active">
    <el-form class="login-form form" :model="form" status-icon ref="form">
      <el-form-item prop="username">
        <el-input v-model="form.username" :placeholder="placeholder" class="win_input"></el-input>
      </el-form-item>
      <el-form-item v-if="!isyzmlogin">
        <el-input v-model="form.password" placeholder="请输入您的密码" class="win_input" type="password"></el-input>
      </el-form-item>
      <el-form-item v-if="isyzmlogin">
        <el-input  placeholder="请输入验证码" v-model="form.password" :class="flag ? 'win_input phone' : 'win_input phones'"></el-input>
        <el-button type="primary" :disabled="flag" class="validation" @click="sendCode()">{{ yzmmsg }}</el-button>
        <p class="tip_p" v-if="isShow">验证码5分钟之内有效,请注意查收</p>
      </el-form-item>
      <el-button type="primary" class="login_btn" @click="login()">立即登录</el-button>
      <div class="tip_p">
        <span class="fl msg" @click="forgotpassword">忘记密码？</span>
        <span class="fr msg" @click="isaccount">{{ msg }}</span>
      </div>
    </el-form>
  </div>
</template>

<script>

import Encrypt from '../layout/Encrypt'
import axios from 'axios'

export default {
  inject: ['reload'],
  data()
  {
    return {
      form: {
        username: '',
        password: ''
      },
      isaccountflag: false,
      isyzmlogin: false,
      flag: false,
      isShow: false,
      placeholder: '请输入手机号',
      msg: '验证码登录',
      yzmmsg: '获取验证码',
      num: 1
    }
  },
  created()
  {
    //登录事件绑定至键盘回车上
    let lett = this
    document.onkeydown = function(e)
    {
      let key = window.event.keyCode
      if (key === 13)
        lett.login()
    }
  },
  methods: {
    /**
     * 字符串转字节数组
     * @static
     * @method
     * @param   {String}    str               字符串
     * @returns {Array.<byte>}                返回字节数组
     */
    strToBytes(str)
    {
      const bytes = []
     
      for (let i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i))
     
      return bytes
    },
    /**
      * 字节数组转字符串
      * @static
      * @method
      * @param   {String}    bytes             字节数组
      * @returns {Array.<byte>}                返回字节数组
      */
    bytesToStr(bytes)
    {
      const str = []
        
      for (let i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]))
        
      return str.join('')
    },
    login()
    {
      if (this.form.username !== '' && this.form.password !== '')
      {
        if (this.isyzmlogin)//手机号或者邮箱登录
        {
          if (this.form.username.indexOf('@') !== -1)
            this.num = 3//邮箱登录
          else
          {
            // this.num = 4//手机号登录
            this.sendSmsLogin()
          }
        }
        else
        {
          this.num = 1//用户名登录
          let paras =
        {
          cmd: 'login',
          username: Encrypt.encrypt(this.form.username, this.bytesToStr(this.strToBytes(window.loginKey))),
          password: Encrypt.encrypt(this.form.password, this.bytesToStr(this.strToBytes(window.loginKey))),
          mode: this.num,
          type: 1,
          sys: 11
        }
          window.post.getLogin(paras).then(ret =>
          {
            if (ret.ret === 1)
            {
              if (this.num === 1)
                this.$message({message: '请检查您的用户名和密码是否正确', type: 'error', customClass: 'mzindex'})
              if (this.num === 2)
                this.$message({message: '请检查您的手机号和密码是否正确', type: 'error', customClass: 'mzindex'})
              if (this.num === 3)
                this.$message({message: '请检查您的邮箱和密码是否正确', type: 'error', customClass: 'mzindex'})
              if (ret.errcode === 'errNoUser')
                this.$message({message: '该手机号还未注册，请先注册后登录', type: 'error', customClass: 'mzindex'})
            }
            else
            {
              localStorage.setItem('username', ret.username)
              this.$message({message: '登录成功', type: 'success', customClass: 'mzindex'})
              if (localStorage.getItem('username'))
              {
                // this.$router.push({path: '/Members'})
                this.$router.go(-1)
                this.reload()
              }
            }
          })
        }
      }
      else
      {
        if (this.form.username === '')
        {
          if (this.num === 1 && this.isaccountflag === false)
            this.$message({message: '请输入您的用户名', type: 'warning', customClass: 'mzindex'})
          else
            this.$message({message: '请输入您的手机号或者邮箱', type: 'warning', customClass: 'mzindex'})
        }
        else if (this.form.password === '')
          this.$message({message: '请输入您的密码', type: 'warning', customClass: 'mzindex'})
      }
    },
    sendSmsLogin()
    {
      let obj = {
        code: this.form.password,
        cell: this.form.username
      }
      axios.post('/svr/zgis/massvr/verifySms', obj,
        {
          headers:
            {
              'Content-Type': 'application/json'
            }
        })
        .then(response =>
        {
          if (response.data.ret === 0)
          {
            localStorage.setItem('username', this.form.username)
            this.$message({message: '登录成功', type: 'success', customClass: 'mzindex'})
            if (localStorage.getItem('username'))
            {
              this.$router.go(-1)
              this.reload()
            }
          }
        })
    },

    forgotpassword()
    {
      let url = this.$router.resolve({path: '/Forgotpassword'})
      window.open(url.href, '_blank')
    },
    isaccount()
    {
      // if (this.msg === '手机或者邮箱登录')
      // {
      //   this.isaccountflag = true
      //   this.msg = '用户名登录'
      //   this.placeholder = '请输入手机号或者邮箱'
      // }
      // else
      // {
      //   this.isaccountflag = false
      //   this.msg = '手机或者邮箱登录'
      //   this.placeholder = '请输入用户名'
      // }
      if (this.msg === '验证码登录')
      {
        this.isyzmlogin = true
        this.msg = '密码登录'
      }
      else
      {
        this.isyzmlogin = false
        this.msg = '验证码登录'
        this.placeholder = '请输入用户名'
      }
    },
    //发送短信
    sendCode()
    {
      let regtel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (regtel.test(this.form.username))
      {
        let obj = {
          // cmd: 'sendCode2',
          // retAtt: 1,
          keyno: 'code_register',
          cell: this.form.username
        }
        axios.post('/svr/zgis/massvr/sendSms', obj,
          {
            headers:
            {
              'Content-Type': 'application/json'
            }
          })
          .then(response =>
          {
            if (response.data.ret === 0)
            {
              this.$message({message: '短信已发送至您的手机，请在验证码有效期使用', type: 'success', customClass: 'mzindex'})
              //获取验证码按钮倒计时功能的实现
              const _this = this
              this.flag = true//按钮不可重复点击
              _this.isShow = true//显示提示文字
              var time = 60//定义时间变量 60s
              var timer = null//定义定时器
              timer = setInterval(function()
              {
                if (time === 0)
                {
                  _this.yzmmsg = '重新获取验证码'
                  _this.flag = false
                  _this.isShow = false
                  clearInterval(timer)//清除定时器
                }
                else
                {
                  _this.yzmmsg = time + '秒后重新获取'
                  time--
                }
              }, 1000)
            }
          })
          .catch(error =>
          {
            console.error('Error:', error)
          })
      }
      else
        this.$message({message: '请输入正确手机号后再获取验证码', type: 'error', customClass: 'mzindex'})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/login/TheLogin.vue